
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inbox/[[...conversationId]]",
      function () {
        return require("private-next-pages/inbox/[[...conversationId]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inbox/[[...conversationId]]"])
      });
    }
  